export default __webpack_public_path__ + "static/media/soft14.6bad5c98.jpg";